import React, { Component } from 'react';
import Loader from "components/Loader";

export default class Link extends Component {

  moveToAppLink(android_url , ios_url , ios_appstore_url) {
    var result_mo_chk = this.checkOs();
    if(result_mo_chk !== "pc"){
      if(result_mo_chk === "ios") {
        setTimeout(() => {
          window.open(ios_appstore_url);
        }, 1500);
        window.location.href = ios_url;
      } else {
        window.location.href = android_url;
      }
    } else {
      window.location.href = 'https://korda.im';
    }
  }

  checkOs() {
    const mobile = (/iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase()));
    let os = 'pc';
    if (mobile) {
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search("android") > -1){
        return os = "android";
      } else if ((userAgent.search("iphone") > -1) || (userAgent.search("ipod") > -1) || (userAgent.search("ipad") > -1)){
        return os = "ios";
      } else {
        return os = "other";
      }
    }
  }

  componentDidMount() {
    this.moveToAppLink(
      // 'intent://instagram.com/#Intent;package=com.instagram.android;scheme=https;end', //insta ok
      'intent://join#Intent;scheme=cengold;package=com.cengold.korda;end',
      // 'intent://join#Intent;scheme=cengold;package=com.cengold.korda;end'
      'cengold://join',
      'https://apps.apple.com/kr/app/%EC%84%BC%EA%B3%A8%EB%93%9C-cengold/id1484761981'
    );
  }

  render() {
    return <Loader/>
    // return (
    //   <a href="cengold://join">cengold://join 호출</a>
    // )
  }
}
